<template>
    <div class="boradcast">
        <Table :loading="loading" :data="list" :columns="columns" :show-header="false">

        </Table>
        <div class="pagination">
            <Page :page-size="LIST_COUNT" :current="page" :total="total" @on-change="changePage" show-total>
            </Page>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import { awpHost } from "config/env.conf";
    import { noticeList } from "api/tripNotify";
    const LIST_COUNT = 10;

    export default {
        data() {
            return {
                LIST_COUNT,
                page: 1,
                list: [],
                loading: true,
                total: 0,
                columns: [
                    {
                        key: "title",
                        render: (h, params) => {
                            return h("div", [
                                h("strong", {
                                    style: {
                                        verticalAlign: "middle",
                                        fontSize: "15px",
                                        cursor: "pointer"
                                    },
                                    attrs: {
                                        "data-id": params.row.id
                                    },
                                    domProps: {
                                        innerHTML: params.row.title
                                    },
                                    on: {
                                        click: this.jumpAway
                                    }
                                }),
                                params.row.isNew
                                    ? h("Badge", {
                                        props: {
                                            count: "new"
                                        },
                                        style: {
                                            verticalAlign: "baseline",
                                            paddingLeft: "10px"
                                        }
                                    })
                                    : ""
                            ]);
                        }
                    },
                    {
                        key: "publishTime",
                        align: "right"
                    }
                ]
            };
        },
        created() {
            this.updateList();
        },
        computed: {
            title() {
                return this.$route.meta.title;
            },
            bizLineId() {
                return this.$route.meta.bizLineId;
            }
        },
        watch: {
            "$route.meta.bizLineId": function() {
                this.page = 1;
                this.updateList();
            }
        },
        methods: {
            updateList: async function() {
                this.loading = true;
                try {
                    const res = await noticeList({
                        page: this.page,
                        pageCount: LIST_COUNT,
                        publishType: 3,
                        servicePlatform: 1,
                        bizlineId: this.$route.meta.bizLineId
                    });
                    console.log(res);
                    // 处理data中的时间
                    if (res.data.length > 0) {
                        for (var one of res.data) {
                            one.publishTime = moment(one.publishTime).format(
                                "YYYY-MM-DD hh:mm:ss"
                            );
                        }
                    }
                    this.list = res.data;
                    this.total = res.paging.total;
                } catch (e) {
                    console.log(e);
                }
                this.loading = false;
            },
            getAnnounceDetailUrl: function(id) {
                return `#/announce/${id}`;
            },
            jumpAway: function(e) {
                const id = e.srcElement.getAttribute("data-id");
                const url = this.getAnnounceDetailUrl(id);
                window.open(url, "noticeDetail" + id);
            },
            changePage: function(page) {
                this.page = page;
                this.updateList();
            }
        }
    };
</script>
<style>
.table-responsive {
  margin: 20px;
}
.pagination {
  width: 100%;
  text-align: right;
  padding: 20px;
  margin: 0;
}
.boradcast strong {
  font-weight: normal;
}
.boradcast .tbo-table-cell span {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// broadcast.vue?3f3fc530